import AARTextField from "@/components/AARTextField";
import BaseDrawer from "@/components/BaseDrawer";
import CustomLabel from "@/components/CustomLabel";
import { ComboBox, ComboBoxChangeEvent } from "@progress/kendo-react-dropdowns";
import { TextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { useState } from "react";
import "react-image-crop/dist/ReactCrop.css";

interface IProps {
  showCreateDrawer: boolean;
  setShowCreateDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  addNewProject: any;
  handleChange: (e: TextBoxChangeEvent | ComboBoxChangeEvent) => void;
  onSave: () => void;
  users: any[];
}

function WriteDrawer({
  showCreateDrawer,
  setShowCreateDrawer,
  addNewProject,
  handleChange,
  onSave,
  users,
  ...drawerProps
}: IProps) {
  const [invalidFields, setInvalidFields] = useState<{
    [key: string]: boolean;
  }>({});

  const validateSave = () => {
    return Object.values(invalidFields).every((field) => !field);
  };

  const getConstructionManagerValue = () => {
    return users?.find(
      (item: any) => item.id === addNewProject?.constructionManager
    );
  };

  // Sort the data alphabetically by text
  const sortedUsers = [...users].sort((a, b) => a.name.localeCompare(b.name));

  const renderDrawerContent = () => (
    <div className="grid gap-4">
      <div>
        <AARTextField
          name="name"
          value={addNewProject?.name}
          onChange={handleChange}
          onValidate={(name, isValid) =>
            setInvalidFields((prev) => ({
              ...prev,
              [name]: !isValid,
            }))
          }
          label="Project Name"
          required={true}
          placeholder="Enter Name"
          disabled={false}
          error="Invalid Name"
        />
      </div>
      <div>
        <AARTextField
          name="code"
          value={addNewProject?.code}
          onChange={handleChange}
          onValidate={(name, isValid) =>
            setInvalidFields((prev) => ({
              ...prev,
              [name]: !isValid,
            }))
          }
          label="Code"
          required={true}
          placeholder="Enter Code"
          disabled={false}
          error="Invalid Code"
        />
      </div>
      <div>
        <CustomLabel label="Construction Manager" required={true} />
        <ComboBox
          data={sortedUsers}
          placeholder="Select Construction Manager"
          name="constructionManager"
          value={getConstructionManagerValue() || ""}
          onChange={handleChange}
          clearButton={false}
          filterable={true}
          textField="name"
          dataItemKey="id"
          suggest={true}
        />
      </div>
    </div>
  );

  return (
    <BaseDrawer
      isOpen={showCreateDrawer}
      onClose={() => setShowCreateDrawer(false)}
      title={addNewProject?.id ? "Edit Project" : "Add New Project"}
      primaryActionText={addNewProject?.id ? "Edit Project" : "Create Project"}
      onPrimaryAction={onSave}
      primaryActionDisabled={!validateSave()}
      {...drawerProps}
      maxW="35vw"
    >
      {renderDrawerContent()}
    </BaseDrawer>
  );
}

export default WriteDrawer;
